module.exports = __webpack_public_path__ + "static/img/HighMastLight.cf7c42c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HighMastLight.jpg
// module id = Qufv
// module chunks = 7